import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { api } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import ImagePicker from "@/components/ImagePicker";

export default function AdminAppearance() {
  const { setConfig: setGlobal } = useSite();
  const [cfg, setCfg] = useState(null);
  const [saved, setSaved] = useState(false);

  useEffect(() => { api.get("/site-config").then(setCfg); }, []);

  if (!cfg) return <div className="text-muted-foreground">Cargando...</div>;

  const save = async () => {
    const updated = await api.put("/site-config", cfg);
    setGlobal(updated);
    setSaved(true); setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div data-testid="admin-appearance">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-display text-4xl font-black tracking-tighter mb-1">Apariencia</h1>
          <p className="text-sm text-muted-foreground">Logos, colores y modo por defecto.</p>
        </div>
        <button onClick={save} data-testid="save-appearance" className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary text-primary-foreground rounded-sm font-semibold text-sm">
          <Save className="w-4 h-4" /> {saved ? "Guardado" : "Guardar"}
        </button>
      </div>

      <div className="grid lg:grid-cols-2 gap-8">
        <section className="border border-border rounded-sm p-6 space-y-5">
          <h3 className="font-display font-bold text-xl">Logos</h3>
          <ImagePicker label="Logo modo claro" value={cfg.logo_light} onChange={(v) => setCfg({ ...cfg, logo_light: v })} />
          <ImagePicker label="Logo modo oscuro" value={cfg.logo_dark} onChange={(v) => setCfg({ ...cfg, logo_dark: v })} />
          <ImagePicker label="Favicon" value={cfg.favicon} onChange={(v) => setCfg({ ...cfg, favicon: v })} />
        </section>

        <section className="border border-border rounded-sm p-6 space-y-5">
          <h3 className="font-display font-bold text-xl">Colores y modo</h3>
          <div>
            <label className="text-xs uppercase tracking-widest font-bold mb-1.5 block">Color primario</label>
            <div className="flex items-center gap-2">
              <input type="color" value={cfg.primary_color || "#FF0055"} onChange={(e) => setCfg({ ...cfg, primary_color: e.target.value })} className="w-14 h-10 rounded-sm border border-border bg-background cursor-pointer" />
              <input type="text" value={cfg.primary_color || ""} onChange={(e) => setCfg({ ...cfg, primary_color: e.target.value })} className="flex-1 h-10 px-3 bg-background border border-border rounded-sm text-sm focus:border-primary outline-none" />
            </div>
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest font-bold mb-1.5 block">Color secundario (acento)</label>
            <div className="flex items-center gap-2">
              <input type="color" value={cfg.secondary_color || "#00F0FF"} onChange={(e) => setCfg({ ...cfg, secondary_color: e.target.value })} className="w-14 h-10 rounded-sm border border-border bg-background cursor-pointer" />
              <input type="text" value={cfg.secondary_color || ""} onChange={(e) => setCfg({ ...cfg, secondary_color: e.target.value })} className="flex-1 h-10 px-3 bg-background border border-border rounded-sm text-sm focus:border-primary outline-none" />
            </div>
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest font-bold mb-1.5 block">Modo por defecto</label>
            <select value={cfg.default_theme || "dark"} onChange={(e) => setCfg({ ...cfg, default_theme: e.target.value })} className="w-full h-10 px-3 bg-background border border-border rounded-sm text-sm focus:border-primary outline-none">
              <option value="dark">Oscuro</option>
              <option value="light">Claro</option>
              <option value="auto">Auto (sistema)</option>
            </select>
          </div>
        </section>
      </div>

      <p className="text-xs text-muted-foreground mt-6">Los cambios se aplican al guardar y al recargar la página.</p>
    </div>
  );
}
